import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './assets/font/iconfont.css'
import Print from 'vue-print-nb'
Vue.use(Print)

Vue.config.productionTip = false
Vue.prototype.$baseurl = 'http://182.92.88.169:8069/volunteer-admin'
// Vue.prototype.$baseurl = 'http://192.168.0.62:8069/volunteer-admin'

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
